import { format } from 'date-fns';
import i18n from '@/libs/i18n';

export default function useDate() {
  const resolveDate = (dateInput, formatString) => {
    if (dateInput) {
      const date = new Date(dateInput);

      let dateStr = '';
      try {
        dateStr = format(date, formatString);
      } catch {
        dateStr = `${date.getDate()} ${date.toLocaleString('default', {
          month: 'long',
        })} ${date.getFullYear()}`;
      }

      return dateStr;
    }

    return i18n.t('date.invalid');
  };

  const resolveDateWithSeperator = (dateInput, useSlashSperator = false) => {
    if (dateInput) {
      const date = new Date(dateInput);
      let dateStr = '';

      try {
        dateStr = `${date.getFullYear()}${
          useSlashSperator ? '/' : '-'
        }${date.toLocaleString('default', {
          month: '2-digit',
        })}${useSlashSperator ? '/' : '-'}${date.toLocaleString('default', {
          day: '2-digit',
        })}`;
      } catch {
        return i18n.t('date.invalid');
      }

      return dateStr;
    }

    return i18n.t('date.invalid');
  };

  const resolveTime = (timeInput) => {
    const time = new Date(timeInput);

    try {
      const hours = time.getHours();
      const minutes = time.getMinutes();

      const timeStr = `${hours < 10 ? `0${hours}` : hours}:${
        minutes < 10 ? `0${minutes}` : minutes
      }`;

      return timeStr;
    } catch (err) {
      return '';
    }
  };

  const resolveDateWithComparator = (startDate, endDate) => {
    const today = new Date();
    const yesterday = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);

    yesterday.setDate(today.getDate() - 1);
    today.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);

    let startStr = '';
    let endStr = '';

    if (start.getTime() == today.getTime()) {
      startStr = 'Today';
    }

    if (end.getTime() == today.getTime()) {
      endStr = 'Today';
    }

    if (start.getTime() == yesterday.getTime()) {
      startStr = 'Yesterday';
    }

    if (end.getTime() == yesterday.getTime()) {
      endStr = 'Yesterday';
    }

    if (!startStr) {
      startStr = `${start.toLocaleString('default', {
        day: '2-digit',
      })}/${start.toLocaleString('default', {
        month: '2-digit',
      })}/${start.getFullYear()}`;
    }

    if (!endStr) {
      endStr = `${end.toLocaleString('default', {
        day: '2-digit',
      })}/${end.toLocaleString('default', {
        month: '2-digit',
      })}/${end.getFullYear()}`;
    }

    if (startStr == endStr) {
      return startStr;
    }

    return `${startStr} - ${endStr}`;
  };

  return {
    resolveDate,
    resolveDateWithSeperator,
    resolveTime,
    resolveDateWithComparator,
  };
}
